const SET_ALL_BATCH_GROUPS_TYPES = 'SET_ALL_BATCH_GROUPS_TYPES';

const initialState = {
    allBatchGroupsTypes: [],
};

export const setAllBatchGroupsTypes = (allTypes) => {
    return {
        type: SET_ALL_BATCH_GROUPS_TYPES,
        payload: allTypes,
    };
};

export const batchGroupsTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_BATCH_GROUPS_TYPES:
            return {
                ...state,
                allBatchGroupsTypes: action.payload,
            };
        default:
            return state;
    }
};
